import ExpirationList from '../ExpirationList'
import ExpirationListMobile from '../ExpirationListMobile'
import * as S from './styles'

import AssinaturaVitalícia from '../../../../assets/icons/AssinaturaVitalicia.png'
import AssinaturaVitalíciaPremium from '../../../../assets/icons/AssinaturaVitalíciaPremium.png'
import AssinaturaEssencial from '../../../../assets/icons/AssinaturaEssencial.png'
import AssinaturaOuro from '../../../../assets/icons/AssinaturaOuro.png'
import AssinaturaDegustação from '../../../../assets/icons/AssinaturaDegustacao.png'

import logoDirecao from '../../../../assets/logos/direcao-square.png'
import { IUserOrder } from 'pages/ExpirationInfo/types'

interface IExpirationInfoContentProps {
  userOrders: IUserOrder[]
  isLoading: boolean
}

export enum ProductsEnum {
  subscription = 'Assinatura',
  course = 'Curso',
  module = 'Módulo',
}

const ExpirationInfoContent: React.FC<IExpirationInfoContentProps> = ({
  userOrders,
  isLoading,
}) => {
  const getListIcon = (order: IUserOrder) => {
    if (order.type === 'subscription') {
      const subscriptionImages = {
        AssinaturaVitalícia,
        AssinaturaEssencial,
        AssinaturaOuro,
        AssinaturaDegustação,
        AssinaturaVitalíciaPremium,
      }
      return subscriptionImages[order.name.replace(' ', '')] || logoDirecao
    } else if (!order.icon) {
      return logoDirecao
    }
    return order.icon
  }

  return (
    <S.ExpirationContainer>
      <S.InitialText>
        <h1>Prazos de acesso</h1>
        <p>Visualize detalhes do prazo de acesso dos conteúdos que você adquiriu.</p>
      </S.InitialText>
      <hr />
      <ExpirationListMobile
        id="mobileList"
        userOrders={userOrders}
        isLoading={isLoading}
        getListIcon={getListIcon}
      />
      <ExpirationList
        id="desktopList"
        userOrders={userOrders}
        isLoading={isLoading}
        getListIcon={getListIcon}
      />
    </S.ExpirationContainer>
  )
}

export default ExpirationInfoContent
